import games from '../../../assets/img/svg/cash-register/games.svg';
import manager from '../../../assets/img/svg/cash-register/manager.svg';
import user from '../../../assets/img/svg/cash-register/man-user.svg';
import CategoryItem from './CategoryItem';
import Aplications from './Aplications';
import Managers from './Managers';
import Operators from './Operators';
import { Game, Operator } from '../../../interface/response/CashRegisterDataResponse';
import MoneyRow from './MoneyRow';
import { CashRegisterMode } from '../../../enum/CashRegisterMode';
import { t } from 'i18next';
import { CashRegisterDropdownKey } from '../../../enum/CashRegisterDropdownKey';

interface CategoriesProps {
  aplicationGames: Game[];
  mode: string;
  operators: Operator;
}

const Categories: React.FC<CategoriesProps> = ({ aplicationGames, mode, operators }) => {
  return (
    <div className="categories">
      <div className="category_section" key={CashRegisterDropdownKey.APPLICATIONS_SECTION}>
        <CategoryItem
          icon={games}
          key={CashRegisterDropdownKey.APPLICATIONS}
          label={t('cashRegister.table.details.applications')}
        >
          <Aplications games={aplicationGames} />
        </CategoryItem>
      </div>
      {mode === CashRegisterMode.CASH_REGISTER_DETAILS && (
        <div className="category_section" key={CashRegisterDropdownKey.MANAGERS_SECTION}>
          <CategoryItem
            icon={manager}
            key={CashRegisterDropdownKey.MANAGERS}
            label={t('cashRegister.table.details.managers')}
          >
            <Managers />
          </CategoryItem>
        </div>
      )}
      {mode === CashRegisterMode.OPERATOR_DETAILS && (
        <div className="category_section" key={CashRegisterDropdownKey.OPERATOR_VOUCHERS_SECTION}>
          <div className="container operator_status_container">
            <div className="item">
              <span className="title">{t('cashRegister.table.details.operatorDetails.vouchers')}</span>
              <div className="values">
                <MoneyRow label={t('cashRegister.table.details.payIn')} amount={operators?.VoucherSum?.PayIn} />
                <MoneyRow label={t('cashRegister.table.details.payOut')} amount={operators?.VoucherSum?.PayOut} />
                <MoneyRow label={t('cashRegister.table.details.balance')} amount={operators?.VoucherSum?.Balance} />
              </div>
            </div>
            <div className="item">
              <span className="title">{t('cashRegister.table.details.operatorDetails.android')}</span>
              <div className="values">
                <MoneyRow label={t('cashRegister.table.details.payIn')} amount={operators?.AndroidVoucherSum?.PayIn} />
                <MoneyRow
                  label={t('cashRegister.table.details.payOut')}
                  amount={operators?.AndroidVoucherSum?.PayOut}
                />
                <MoneyRow
                  label={t('cashRegister.table.details.balance')}
                  amount={operators?.AndroidVoucherSum?.Balance}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="category_section" key={CashRegisterDropdownKey.OPERATORS_SECTION}>
        <CategoryItem
          icon={user}
          key={CashRegisterDropdownKey.OPERATORS}
          label={
            mode === CashRegisterMode.CASH_REGISTER_DETAILS
              ? t('cashRegister.table.details.operators')
              : t('cashRegister.table.details.operatorDetails.listOfOperators')
          }
        >
          <Operators mode={mode} />
        </CategoryItem>
      </div>
    </div>
  );
};

export default Categories;
